define("shared/components/shared/post/secondary/publishing-method-setup/setup/card/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--card cPM--secondaryCard">
    <header class="o--cardHeader u--p">
      {{#if @recommended}}
        <div class="u--clearfix u--m__b__xs">
          <span class="cLB--label--sm cLB--label--system">{{t "onboarding.side_wiz.general.cards.badge"}}</span>
        </div>
      {{/if}}
      <p class="o--cardHeader__title cPM--secondaryCard__header">
        {{@svg}}
        {{html-safe @header}}
      </p>
    </header>
    <div class="o--cardBody u--p__lr u--p__t__0">
      <p class={{if @isDisabled "o--blank__desc" "u--m__b"}}>
        {{html-safe @content}}
      </p>
      <Shared::Ui::Button
        @additional="block"
        @isDisabled={{@isDisabled}}
        @onClick={{if @onClick @onClick (noop)}}
        @text={{@buttonText}}
        @variant="default"
        ...attributes
      />
    </div>
  </div>
  */
  {
    "id": "HgDrgTuE",
    "block": "[[[10,0],[14,0,\"o--card cPM--secondaryCard\"],[12],[1,\"\\n  \"],[10,\"header\"],[14,0,\"o--cardHeader u--p\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[10,0],[14,0,\"u--clearfix u--m__b__xs\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"cLB--label--sm cLB--label--system\"],[12],[1,[28,[35,1],[\"onboarding.side_wiz.general.cards.badge\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,2],[14,0,\"o--cardHeader__title cPM--secondaryCard__header\"],[12],[1,\"\\n      \"],[1,[30,2]],[1,\"\\n      \"],[1,[28,[35,2],[[30,3]],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--cardBody u--p__lr u--p__t__0\"],[12],[1,\"\\n    \"],[10,2],[15,0,[52,[30,4],\"o--blank__desc\",\"u--m__b\"]],[12],[1,\"\\n      \"],[1,[28,[35,2],[[30,5]],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,3],[[17,6]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,4],[52,[30,7],[30,7],[28,[37,4],null,null]],[30,8],\"default\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@recommended\",\"@svg\",\"@header\",\"@isDisabled\",\"@content\",\"&attrs\",\"@onClick\",\"@buttonText\"],false,[\"if\",\"t\",\"html-safe\",\"shared/ui/button\",\"noop\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/setup/card/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});